
import './CSS/commandes.scss';
import IndirectCommand from './Assets/Commandes_indirectes.svg'
import DirectCommand from './Assets/CommandesDirect.svg'

export default function Commandes()
{
    return (
        <div className='Page'>
            <h1>Commandes de l'EF9345</h1>

            <p>
                L'EF9345 dispose de plusieurs commandes. Comprenez par là que vous avez différents ordres possibles à lui donner.<br/>
                C'est en fait par celles-ci que tout est possible puisque les commandes vous permettent de configurer les modes graphiques mais aussi d'envoyer des caractères à l'écran, 
                donner les attributs des caractères, en redéfinir, choisir les couleurs, etc.
            </p> 

            <p>
                Il y a deux types de commandes. Les commandes directes et les commandes indirectes
            </p>

            <h2>Commandes indirectes</h2>

            <p>
                Les commandes indirectes sont au nombre de 6 (numérotées de 0 à 7 mais les numéros 5 et 6 sont inexistants).<br/>
                Elles concernent principalement la configuration de l'EF9345.
            </p>

            <p>
                Ces commandes n'utilisent que R1 comme paramètre.<br/> 
                Pour sélectionner une commande vous devez mettre dans R0 la valeur de cette commande tout en mettant le bit 7 à 1.<br/>
                Par exemple pour la commande indirecte 1, vous devez mettre dans R0 : %10000001
            </p>

            <p>
                <img className="commandeIndirect" src={IndirectCommand} alt="Commandes indirectes" />
            </p>

            <h2>Commandes directes</h2>

            <p>
                Ces commandes sont plus complexes et demandent en général plusieurs paramètres.<br/>
                Comme toujours vous les sélectionnerez en mettant leur identifiant dans R0.
            </p> 

            <p>
                Le tableau suivant est un résumé rapide de ces commandes qui seront détaillées par la suite dans les prochains chapitres.
            </p>

            <p>
                <img className="commandeDirect" src={DirectCommand} alt="Commandes Direct" />
            </p>

            <p>
                Ne faites pas attention aux indications telles que R/W, a, a2... Nous verrons aussi cela par la suite.
            </p>

            <h2>Lenteur du VDP</h2>

            <p>
                L'EF9345 est lent, incroyablement lent, et ceci peut nous causer des problèmes.<br/>
                En effet, s'il vous arrivait d'envoyer plusieurs commandes à la suite, vous risqueriez de modifier la commande en court qui n'aurait pas été traitée entièrement.<br/>
                Afin d'éviter ce problème, nous pouvons heureusement tester si le VDP a terminé sa tache en court.
            </p>

            <h2>Tester si le VDP est pret</h2>

            <p>
                Pour tester si le VDP est pret, nous allons regarder si le bit 7 de R0 en lecture est mis ou non.<br/>
                En effet, ce bit correspond au status "BUSY". Aussi, tant que le VDP est occupé, ce bit de status sera mis à 1.<br/>
            </p>

            <pre className='code'>
            0| ;routine d'attente de l'EF9345<br/>
            1| wait<br/>
            2|         LD     A,#20         ;R0<br/>
            3|         OUT    (#8f),A<br/>
            4| isBusy  IN     A,(#CF)<br/>
            5|         OR     A<br/>
            6|         JP     M,isBusy<br/>
            7|         RET
            </pre>


        </div>
    )
}